/** How often, how long and what time the short catch-ups after the appraisal happen. */

export const CADENCES: { value: string; label: string }[] = [
  { value: "weekly", label: "Every week" },
  { value: "fortnightly", label: "Every 2 weeks" },
  { value: "monthly", label: "Every month" },
];
export const LENGTHS = [15, 20, 30];

export function cadenceLabel(value: string | null | undefined): string {
  return CADENCES.find((c) => c.value === value)?.label ?? "";
}

export interface CheckInValue {
  cadence: string;
  minutes: number;
  time: string;
}

function Chips<T extends string | number>({
  options,
  value,
  onChange,
  disabled,
  label,
}: {
  options: { value: T; label: string }[];
  value: T | null;
  onChange: (v: T) => void;
  disabled?: boolean;
  label: string;
}) {
  return (
    <div role="radiogroup" aria-label={label} className="flex flex-wrap gap-1.5">
      {options.map((o) => {
        const on = o.value === value;
        return (
          <button
            key={String(o.value)}
            type="button"
            role="radio"
            aria-checked={on}
            disabled={disabled}
            onClick={() => onChange(o.value)}
            className={`min-h-[36px] rounded-full border px-3 text-xs font-semibold transition-colors disabled:opacity-60 ${
              on ? "border-purple-600 bg-purple-600 text-white" : "border-gray-200 bg-white text-gray-600 hover:border-purple-300"
            }`}
          >
            {o.label}
          </button>
        );
      })}
    </div>
  );
}

export default function CheckInPicker({
  value,
  onChange,
  disabled,
}: {
  value: CheckInValue;
  onChange: (v: CheckInValue) => void;
  disabled?: boolean;
}) {
  return (
    <div className="space-y-3">
      <div>
        <span className="mb-1 block text-xs font-medium text-gray-600">How often</span>
        <Chips label="How often" options={CADENCES} value={value.cadence || null} disabled={disabled}
          onChange={(cadence) => onChange({ ...value, cadence })} />
      </div>
      <div>
        <span className="mb-1 block text-xs font-medium text-gray-600">How long</span>
        <Chips label="How long" options={LENGTHS.map((m) => ({ value: m, label: `${m} min` }))}
          value={value.minutes || 15} disabled={disabled} onChange={(minutes) => onChange({ ...value, minutes })} />
        <p className="mt-1 text-[11px] text-gray-500">Keep them short. 15 minutes is usually enough.</p>
      </div>
      <label className="block">
        <span className="mb-1 block text-xs font-medium text-gray-600">Usual time</span>
        <input
          type="time"
          disabled={disabled}
          value={value.time || "09:30"}
          onChange={(e) => onChange({ ...value, time: e.target.value })}
          className="input w-32"
        />
      </label>
    </div>
  );
}
